<template>
    <sys-register-base 
        :loading="loading" 
        @onSave="saveAll" 
        :model.sync="model" 
        :title="title" 
        icon="mdi-book-open-page-variant" 
        v-bind:show.sync="dialog"
        maxWidth="100%"
        :showRequiredFields="false"
        :showButton="false"
    >
        <template v-slot:form>
            <v-container fluid>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-progress-linear
                                v-if="loading"
                                indeterminate
                                color="cyan lighten-4"
                            />
                            <v-data-table
                                v-if="renderComponent"
                                :items="items"
                                :headers="headers.filter(h => h.visible)"
                                sort-by="calories"
                                class="elevation-1"
                                item-key="index"
                                :hide-default-footer="true"
                                :items-per-page="-1"
                                fixed-header
                                height="400"
                            >
                                <template v-slot:top>
                                    
                                        <v-btn
                                            v-if="showAddItem"
                                            class="ma-2"
                                            color="primary"
                                            @click="showRegisterOccurrenceItem({ occurrence_sheet_id: model.id, teacher_id: model.teacher_id }, -1, 1)"  
                                        >
                                            Adicionar Marcação    
                                            <v-icon>mdi-plus</v-icon>
                                        </v-btn>
                                
                                </template>

                                <template dense v-slot:item.date="{ item }">
                                    
                                    <!-- <emc-calendar-date-picker2
                                        :model.sync="item.date" 
                                        label="" 
                                        :error="errors.length > 0"
                                        :error-messages="errors['items.' + index + '.date']" 
                                        :show="dialog"
                                        :min="dateMin"
                                        :max="dateMax"
                                        :allowed-dates="allowedDates"
                                        dense
                                        :disabled="item.blocked ? true : false"
                                        fieldClass="mb-0 pb-0"
                                    /> -->

                                    {{ item.date | date }}

                                    <br/>

                                    <small class="mt-0 pt-0" v-html="getDescriptionJourney(item)" />
                                   
                                </template>

                                 <template dense v-slot:item.description="{ item }">
                                    
                                    {{ item.description }}
                                                                        
                                    <!-- <v-textarea
                                        class="mt-2"
                                        v-model="item.description"
                                        :error="errors.length > 0"  
                                        :error-messages="errors['items.' + index + '.description']"
                                        label=""
                                        rows="3"
                                        auto-grow
                                        outlined
                                       :disabled="item.blocked ? true : false"
                                    /> -->

                                </template>

                                <!-- Marcação 1 -->
                                <template dense v-slot:item.check_in_1="{ item }">

                                    <s-text-field v-mask="'00:00'" clearable placeholder="HH:MM" :rules="[validateTime]" :error-messages="errors.check_in_1" v-model="item.check_in_1" label="" />

                                </template>

                                <template dense v-slot:item.check_out_1="{ item }">

                                    <s-text-field  v-mask="'00:00'" clearable placeholder="HH:MM" :rules="[validateTime]" :disabled="!item.check_in_1 && !item.check_out_1" :error-messages="errors.check_out_1" v-model="item.check_out_1" label="" />

                                </template>

                                <!-- Marcação 2 -->
                                <template dense v-slot:item.check_in_2="{ item }">

                                    <s-text-field  v-mask="'00:00'" clearable placeholder="HH:MM" :rules="[validateTime]"  :disabled="!item.check_out_1 && !item.check_in_2" :error-messages="errors.check_in_2" v-model="item.check_in_2" label="" />

                                </template>

                                <template dense v-slot:item.check_out_2="{ item }">

                                    <s-text-field v-mask="'00:00'" clearable placeholder="HH:MM" :rules="[validateTime]" :disabled="!item.check_in_2 && !item.check_out_2" :error-messages="errors.check_out_2" v-model="item.check_out_2" label="" />

                                </template>

                                 <!-- Marcação 3 -->
                                <template dense v-slot:item.check_in_3="{ item }">

                                    <s-text-field v-mask="'00:00'" clearable placeholder="HH:MM" :rules="[validateTime]" :disabled="!item.check_out_2 && !item.check_in_3" :error-messages="errors.check_in_3" v-model="item.check_in_3" label="" />

                                </template>

                                <template dense v-slot:item.check_out_3="{ item }">

                                    <s-text-field v-mask="'00:00'" clearable placeholder="HH:MM" :rules="[validateTime]" :disabled="!item.check_in_3 && !item.check_out_3" :error-messages="errors.check_out_3" v-model="item.check_out_3" label="" />

                                </template>

                                 <!-- Marcação 4 -->
                                <template dense v-slot:item.check_in_4="{ item }">

                                    <s-text-field v-mask="'00:00'" clearable placeholder="HH:MM" :rules="[validateTime]" :disabled="!item.check_out_3 && !item.check_in_4" :error-messages="errors.check_in_4" v-model="item.check_in_4" label="" />

                                </template>

                                <template dense v-slot:item.check_out_4="{ item }">

                                    <s-text-field v-mask="'00:00'" clearable placeholder="HH:MM" :rules="[validateTime]" :disabled="!item.check_in_4 && !item.check_out_4" :error-messages="errors.check_out_4" v-model="item.check_out_4" label="" />

                                </template>


                                <template dense v-slot:item.type="{ item}">

                                    
                                    <span v-if="item.type">
                                        <emc-info-help v-if="item.note || item.motive" title="Justificativa">
                                            <template v-slot:text>
                                                
                                                <span v-if="item.motive">
                                                    {{ item.motive.name }}
                                                    <small v-if="item.note"></small>
                                                </span>
                                                <span v-else-if="item.note">
                                                    {{ item.note }}
                                                </span>
                                                
                                            </template>
                                        </emc-info-help>
                                        {{ item.type.name }}
                                    </span>
                                    
                                </template>

                                <!-- <template dense v-slot:item.occurrence_status_id="{ item, index }">
                                    <sys-select-occurrence-status
                                        :model.sync="item.occurrence_status_id"
                                        :error="errors.length > 0"  
                                        :errors="errors['items.' + index + '.occurrence_status_id']"
                                        label=""
                                    />
                                </template> -->

                                <template v-slot:item.actions="{ item, index }">

                                    <span>
                                        
                                        <emc-button-icon
                                            v-if="!hideEdit"
                                            :loading="index == indexItem && loadingUpdate"
                                            icon="mdi-content-save-outline"
                                            color="success"
                                            @click="updateItem(item, index)"
                                            :disabled="disabledActions"
                                            text="Salvar Marcações"
                                            text-button="Salvar"
                                        />

                                        <br/>
                                        <v-divider></v-divider>
                                        <emc-button-icon
                                            v-if="!hideDelete"
                                            :loading="index == indexItem && loadingDelete"
                                            icon="mdi-calendar-plus"
                                            color="primary"
                                            @click="showRegisterOccurrenceItem(item, index, 0)"
                                            :disabled="disabledActions"
                                            text='Cadastrar Ocorrência'
                                            text-button="Ocorrência"
                                            
                                        />
                                    </span>

                                    
                                </template>
                            
                            </v-data-table>
                        </v-col>
                    </v-row>
            </v-container>

             <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>

            <sys-occurrence-teacher-register :new-item="newItem" @onCompleted="getData()" :allowedDates="allowedDates" :model="selectedOccurrenceItem" v-bind:show.sync="showFormRegisterItem" />

            
        </template>

       
       
    </sys-register-base>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: "SysOccurrenceSheetSheetTeacherItemRegister",
    data: (vm) => ({
        dialog: false,
        error: false,
        errors: {},
        message: '',
        selectedOccurrenceType: null,
        selectedOccurrenceItem: {},
        showFormRegisterItem: false,
        newItem: 0,
        occurrence_type_id: null,
        dateMin: null,
        dateMax: null,
        allowedDates: null,
        position: null,
        occurrence_sheet_register_motive_id: null,
        minNote: 5,
        maxNote: 255,
        note: null,
        indexItem: -1,
        disabledActions: false,
        items: [],
        loading: false,
        loadingUpdate: false,
        loadingDelete: false,
        renderComponent: true,
        markings: ['check_in_1', 'check_out_1', 'check_in_2', 'check_out_2', 'check_in_3', 'check_out_3' ],
        headers: [
            { text: 'Data/Horário',         value: 'date',                  align: 'start', sortable: false, visible: true, width: '12%' },
            { text: 'Descrição',    value: 'description',           align: 'start', sortable: false, visible: true, width: '30%'  },
            { text: 'Entrada 1',     value: 'check_in_1',           align: 'start', sortable: false, visible: true, width: '10%'  },
            { text: 'Saída 1',       value: 'check_out_1',             align: 'start', sortable: false, visible: true, width: '10%'  },
            { text: 'Entrada 2',     value: 'check_in_2',           align: 'start', sortable: false, visible: true, width: '10%'  },
            { text: 'Saída 2',       value: 'check_out_2',             align: 'start', sortable: false, visible: true, width: '10%'  },
            { text: 'Entrada 3',     value: 'check_in_3',           align: 'start', sortable: false, visible: true, width: '10%'  },
            { text: 'Saída 3',       value: 'check_out_3',             align: 'start', sortable: false, visible: true, width: '10%'  },
            { text: 'Entrada 4',     value: 'check_in_4',           align: 'start', sortable: false, visible: true, width: '10%'  },
            { text: 'Saída 4',       value: 'check_out_4',             align: 'start', sortable: false, visible: true, width: '10%'  },
            { text: 'Ocorrência',   value: 'type',                  align: 'center',sortable: false, visible: true, width: '10%'  },
            { text: 'Status',       value: 'occurrence_status_id',  align: 'center',sortable: false, visible: false, width: '10%'  },
            { text: '',             value: 'actions',               align: 'center',sortable: false, visible: true, width: '10%' },
        ],
    }),
    created(){

    },

    computed: {
      ...mapState('auth', ['acesso']),

      disabledSave(){
            
            let value = this.loadingDelete || this.note === null || this.note.length < this.minNote || this.note.length > this.maxNote || !this.occurrence_type_id;

            if(this.selectedOccurrenceType && this.selectedOccurrenceType.requires_motive){
                value = value || !this.occurrence_sheet_register_motive_id;
            }

            return value;

        },

    },

    watch: {
        
        dialog(dialog_new, dialog_old) {
            
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {
            
            this.dialog = show_new;

            if(show_new){
                
                
                this.dateMin = this.model.info_date.start;
                this.dateMax = this.model.info_date.end;
                this.allowedDates = this.model.info_date.allowed_dates;

                this.error = false;
                this.errors = {};
                this.getData();
                this.getLocation();


            }
        },
        
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-alert"
        },
        title: {
            type: String,
            default: "Marcações de Ponto"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        },
        hideDelete: {
            type: Boolean,
            default: false
        },
        hideEdit: {
            type: Boolean,
            default: false
        },
        showAddItem: {
            type: Boolean,
            default: false
        },
        showEditMark: {
            type: Boolean,
            default: true
        },

    },
    methods:{
        ...mapActions('timeSheet', ['ActionIndexOccurrenceSheetItems', 'ActionUpdateOccurrenceSheet', 'ActionStoreOccurrenceSheetItem', 'ActionUpdateOccurrenceSheetItem', 'ActionDestroyOccurrenceSheetItem', 'ActionAbsenceRegisterSheetItem']),

        getData(){

                this.loading = true;
                this.items = [];
                this.showFormRegisterItem = false;

                var payload = {
                    find_columns: {
                        occurrence_sheet_id: this.model.id,
                    },
                    select: 'info_date',
                    with: 'registers,type,motive',
                }

                this.ActionIndexOccurrenceSheetItems(payload)
                    .then((res) => {
                        this.items = res.data;
                    })
                    .finally(() => {
                        this.loading = false;
                        this.loadMarks();
                    });

        },

        changeType(ev){
            this.selectedOccurrenceType = ev;
            this.occurrence_sheet_register_motive_id = null;
        },  

        getDescriptionJourney(item)
        {
            
            let description = '';
            
            for (let index = 1; index <= 6; index++) {
                
                let start = 'hour_start' + index;
                let end = 'hour_end' + index;
                
                if(!item[start] &&  !item[end]){
                    continue;
                }
                
                if(description != ''){
                    description += '<br/>';
                }

                if(item[start]){
                    description += item[start].substring(0, 5);
                }

                if(item[end]){
                    description += ' - ' + item[end].substring(0, 5);
                }
                
            }
            
            return description;
        },

        getLocation()
        {
            if (navigator.geolocation)
            {
                navigator.geolocation.getCurrentPosition((pos) => {
                    
                    this.position = {
                        lat: pos.coords.latitude,
                        lng: pos.coords.longitude
                    };
                });
            }
            
        },

        loadMarks(){

            this.items.forEach(item => {
                
                let index = 0;
                
                for (let i = 0; i < item.registers.length; i++) {
                    
                    let reg = item.registers[i];
                    
                    if(reg.action == 'I' || reg.action == 'U'){
                        item[this.markings[index++]] = reg.time;
                    }
                }
            });

        },
        
        saveAll(){
            
            this.loading = true;
            this.error = false;
            this.errors = {};

            this.items.forEach(item => {
                this.loadRegisters(item);
            });
            
            this.ActionUpdateOccurrenceSheet(this.model)
                .then((res) => {
                    item.id = res.data.id;
                    item.registers = res.data.registers;
                })
                .catch((error) =>{
                    this.error = true;
                    this.errors = error.errors;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        removeItem(item){
          var index = this.items.indexOf(item);
          this.items.splice(index, 1);
          this.showFormRegisterItem = false;
          this.forceRerender();
        },

        updateItem(item, index){
          
          var method = item.id ? 'ActionUpdateOccurrenceSheetItem' : 'ActionStoreOccurrenceSheetItem';
          this.loadingUpdate = true;
          this.indexItem = index;
          this.message = '';
          this.error = false;
          this.errors = {};
            
          this.loadRegisters(item);

          this[method](item)
            .then((res) => {
                
                item.id = res.data.id;
                item.registers = res.data.registers;
                this.message = "Marcação atualizada com sucesso"

            })
            .catch((error) =>{
                
                Object.keys(error.errors).forEach(key => {
                    this.errors['items.' + index + '.' + key] = error.errors[key];
                });

                this.error = true;
                this.message = error.message;
            })
            .finally(() => {
                  this.loadingUpdate = false;
                  this.indexItem = -1;
                  //this.forceRerender();
            });
            
      },

      loadRegisters(item){

        let registersOriginal = item.registers;
        let registers = [];
        
        for (let i = 0; i < this.markings.length; i++) {
                
                let date    = item.date;
                let time    = item[this.markings[i]];
                
                if(time){

                    let reg = registersOriginal.find(r => (r.time == time && r.date == date));

                    if(reg){
                        registers.push(reg);
                    }else{
                        registers.push({
                            id:                                 0,
                            occurrence_sheet_item_id:           item.id,
                            occurrence_intervention_type_id:    1, // 2 = Incluído | 4 = Exceção
                            date:                               date,
                            time:                               time,
                            localization:                       this.position ? (this.position.lat + ';' + this.position.lng) : null,
                        });
                    }

                }

            }

            item.registers = registers;
      },

      showRegisterOccurrenceItem(item, index, newItem)
      {
        
        this.selectedOccurrenceItem = item;
        this.indexItem = index;
        this.newItem = newItem;
        this.showFormRegisterItem = true;
           
      },

      deleteItem(){
          
          let item = this.selectedOccurrenceItem;
          
          if(!item.id){
            this.removeItem(item);
            return;
          }
          
          this.loadingDelete = true;
          this.error = false;
          this.errors = {};
          let payload = {
            id: item.id,
          };
          
          this.ActionDestroyOccurrenceSheetItem(payload)
            .then((res) => {
                this.removeItem(item);
            })
            .catch((error) =>{
                
                
            })
            .finally(() => {
                  this.loadingDelete = false;
                  this.indexItem = -1;
                  this.showFormRegisterItem = false;
                  this.selectedOccurrenceItem = {};
                  this.forceRerender();
            });
            
      },

      absenceItem(){
          
          let item = this.selectedOccurrenceItem;
          
          this.loadingDelete = true;
          this.error = false;
          this.errors = {};
          let payload = {
            id: item.id,
            note: this.note,
            occurrence_type_id: this.occurrence_type_id,
            occurrence_sheet_register_motive_id: this.occurrence_sheet_register_motive_id,
          };
          
          this.ActionAbsenceRegisterSheetItem(payload)
            .then((res) => {
                
            })
            .catch((error) =>{
                
                
            })
            .finally(() => {
                  this.loadingDelete = false;
                  this.indexItem = -1;
                  this.showFormRegisterItem = false;
                  this.selectedOccurrenceItem = {};
                  this.getData();
            });
      },

      addItem(){
          
          if(!this.model){
            return;
          }

          var length = this.items.length;
          
          var item = {
              index:                        length,
              id:                           0,
              occurrence_sheet_id:          this.model.id,
              occurrence_record_type_id:    1,
              occurrence_type_id:           null,
              occurrence_sheet_register_motive_id: null,
              occurrence_status_id:         1,
              date:                         null,
              hour_start1:                  null,
              hour_end1:                    null,
              hour_start2:                  null,
              hour_end2:                    null,
              hour_start3:                  null,
              hour_end3:                    null,
              description:                  null,
              registers:                    [],
          };

          this.items.unshift(item);
          this.forceRerender();
          
      },

    validateTime(value) {
        
        if (!value) return true // Se vazio, sem erro
        if (value.length === 0) return true // sem erro se vazio
        if (value.length < 5) return true   // ainda digitando, não valida
        
        const regex = /^([01]\d|2[0-3]):([0-5]\d)$/
        return ( regex.test(value)) || 'Hora inválida. Use o formato HH:MM (00:00 a 23:59)'
    },

      forceRerender () {
      
        this.renderComponent = false;

        this.$nextTick(() => {
            this.renderComponent = true;
        });
    }

      

    }
}
</script>